import {Paper} from '@material-ui/core';
import {useBreadcrumbs} from 'Core/hooks/useBreadcrumbs';
import React, {useEffect} from 'react';
import {RouteComponentProps} from 'react-router-dom';
import {useSelector, useDispatch} from 'react-redux';
import {ReducerState} from 'rootReducer';
import {matchAsyncPage} from 'Core/models/Async';
import AgentNewsList from 'Agent/AgentInformation/components/AgentNewsList';
import ErrorMessage from 'Shared/components/ErrorMessage';
import {getNews} from 'Agent/AgentInformation/ducks/news';
import Loading from 'Shared/components/Loading';
import 'Agent/AgentInformation/components/AgentNews.sass';

type AgentNewsProps = RouteComponentProps;

const AgentNews = (props: AgentNewsProps) => {
  const {match} = props;
  const news = useSelector((state: ReducerState) => state.news);
  const dispatch = useDispatch();
  useBreadcrumbs('Agent News', match.url);

  useEffect(() => {
    dispatch(getNews());
  }, []);

  return (
    <div className="agent-news">
      <Paper className="agent-news__paper">
        <h1 className="agent-news__header">
          Agent News &nbsp;
          <i className="fa fa-newspaper" />
        </h1>
        {matchAsyncPage(news, {
          Conflict: e => <ErrorMessage errorMessage={e.message} />,
          ServerError: e => <ErrorMessage errorMessage={e.message} />,
          Unauthorized: e => <ErrorMessage errorMessage={e.message} />,
          Loading: () => <Loading />,
          Loaded: loadedNews => <AgentNewsList newsPage={loadedNews} />,
        })}
      </Paper>
    </div>
  );
};

export default AgentNews;
